import script from "./HintText.vue?vue&type=script&lang=ts&setup=true"
export * from "./HintText.vue?vue&type=script&lang=ts&setup=true"

import "./HintText.vue?vue&type=style&index=0&id=db3f5732&lang=less"

const __exports__ = script;

export default __exports__